import { gql } from '../../__generated__';

export interface KotobeeBookCloudIdModel {
  id: string;
  bookName: string;
  cloudId: number;
}

export interface UpsertKotobeeBookCloudIdResponse {
  upsertKotobeeBookCloudId: KotobeeBookCloudIdModel;
}

export interface GetKotobeeBookCloudIdsResponse {
  getKotobeeBookCloudIds: KotobeeBookCloudIdModel[];
}

export interface UpsertKotobeeBookCloudIdVariables {
  input: {
    bookName: string;
    cloudId: number;
  };
}

export interface DeleteKotobeeBookCloudIdResponse {
  deleteKotobeeBookCloudId: boolean;
}

export interface DeleteKotobeeBookCloudIdVariables {
  input: {
    id: string;
  };
}

export const UPSERT_KOTOBEE_BOOK_CLOUD_ID = gql(`
  mutation UpsertKotobeeBookCloudId($input: UpsertKotobeeBookCloudIdInput!) {
    upsertKotobeeBookCloudId(input: $input) {
      id
      bookName
      cloudId
    }
  }
`);

export const GET_KOTOBEE_BOOK_CLOUD_IDS = gql(`
  query GetKotobeeBookCloudIds {
    getKotobeeBookCloudIds {
      id
      bookName
      cloudId
    }
  }
`);

export const DELETE_KOTOBEE_BOOK_CLOUD_ID = gql(`
  mutation DeleteKotobeeBookCloudId($input: DeleteKotobeeBookCloudIdInput!) {
    deleteKotobeeBookCloudId(input: $input)
  }
`);